<script setup>
defineProps({
  item: Object,
})

const { hour, minutes, tearDownClock } = useClock()
onUnmounted(tearDownClock)
const clockText = computed(() => `${hour.value}:${minutes.value}`)
</script>

<template>
  <div class="size-full">
    <div class="absolute right-[120px] top-[125px] w-[125px] text-center text-white text-3xl font-bold text-shadow-glow" v-text="clockText" />
  </div>
</template>
